import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  DatePicker,
  Select,
} from "antd";
import { disableFutureDates } from "../../generalFunctions";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import dayjs from "dayjs";

function AddAuthorisationLetter(props) {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/authorisation-letter",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/authorisation-letter/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );
  const [categoryResponse, categoryRequest] = useApi(
    "/config/category/dropdown",
    null,
    API_METHODS.GET
  );
  const [productsResponse, productsRequest] = useApi(
    "/config/product/dropdown",
    null,
    API_METHODS.GET
  );

  const [categories, setcategories] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    categoryRequest();
    productsRequest();
  }, []);

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Authorisation added successfully.",
      });
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Authorisation updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue({
        ...selectedRecord,
        to_date: selectedRecord.to_date
          ? dayjs(selectedRecord.to_date)
          : undefined,
        from_date: selectedRecord.from_date
          ? dayjs(selectedRecord.from_date)
          : undefined,
      });
    }
  }, [selectedRecord]);

  useEffect(() => {
    const data =
      categoryResponse.data !== BLANK_VALUE ? categoryResponse.data : [];
    setcategories(data);
  }, [categoryResponse]);

  useEffect(() => {
    const data =
      productsResponse.data !== BLANK_VALUE ? productsResponse.data : [];
    setProducts(data);
  }, [productsResponse]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        } else {
          request(values, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    form.resetFields();
    close();
  };

  const countyChanged = (event) => {
    form.setFieldValue("territory", event.target.value);
  };
  return (
    <Modal
      title={selectedRecord ? "Update Authorisation" : "Add Authorisation"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="company_name"
              label="Company"
              rules={[
                { required: true, message: "Company is required." },
                {
                  max: 200,
                  message: "Company should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="company_address1"
              label="Company address 1"
              rules={[
                { required: true, message: "Company address is required." },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="company_address2" label="Company address 2">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="pincode" label="Pincode">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="country" label="Country">
              <Input onChange={countyChanged} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="recipient_name" label="Recipient Name">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="recipient_email" label="Recipient Email">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="recipient_phone" label="Recipient Mobile">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="territory" label="Territory">
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="category_ids" label="Category">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                mode="multiple"
              >
                {categories?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.category}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="product_ids" label="Product">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                mode="multiple"
              >
                {products?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.product_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="from_date" label="From Date">
              <DatePicker
                format={"DD-MM-YYYY"}
                disabledDate={disableFutureDates}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="to_date" label="To Date">
              <DatePicker format={"DD-MM-YYYY"} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddAuthorisationLetter;
